import React, { useState, useEffect } from "react";
import Checkbox from "../fields/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { filterCars } from "../../redux/Slice/carSlice";
import { toast } from "react-toastify";
import RadioInput from "../fields/RadioInput";
import { Switch } from "@mui/material";
// import Checkbox from '../fields/Checkbox'
import { styled } from "@mui/material/styles";
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 50,
  height: 26,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(24px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 3,
    "&.Mui-checked": {
      transform: "translateX(24px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#008080 !important", // Track color when checked
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 20,
    height: 20,
    borderRadius: 15,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 15,
    opacity: 1,
    backgroundColor: "#424242 !important", // Track color when unchecked
    boxSizing: "border-box",
  },
}));
const CustomSelection = ({
  setIsSearched,
  categories,
  setCurrentPage,
  isChecked,
  setSearchFormQuery,
  setPriceOrder,
}) => {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const categoriesData = useSelector((state) => state?.config?.categories);
  const carMakeList = useSelector((state) => state?.form?.carMakeList);
  const carModals = useSelector((state) => state?.config?.carModals);
  const [selectedValues, setSelectedValues] = useState({
    cartType: [],
    carMake: [],
    carModel: [],
    fuelType: [],
    price: [],
    seatingCapacity: [],
  });
  // console.log("selectedValues", selectedValues);

  const [fuelType, setFuelType] = useState([
    {
      _id: "Diesel",
      name: "Diesel",
    },
    {
      _id: "Petrol",
      name: "Petrol",
    },
    {
      _id: "Electric",
      name: "Electric",
    },
    {
      _id: "Gas",
      name: "Gas",
    },
    {
      _id: "Hybrid",
      name: "Hybrid",
    },
  ]);
  const [seatList, setSeatList] = useState([
    {
      _id: "2",
      name: "2 Seater",
    },
    {
      _id: "3",
      name: "3 Seater",
    },
    {
      _id: "4",
      name: "4 Seater",
    },
    {
      _id: "5",
      name: "5 Seater",
    },
    {
      _id: "6",
      name: "6 Seater",
    },
    {
      _id: "7",
      name: "7+ Seater",
    },
  ]);
  const [price, setPrice] = useState([
    {
      _id: "lowToHigh",
      lable: "Low to High",
      name: "price",
      value: 1,
      // name: "Low to High",
      // _id: "Low to High",
    },
    {
      _id: "highToLow",
      lable: "High to Low",
      name: "price",
      value: -1,
      // name: "High to Low",
      // _id: "High to Low",
    },
  ]);

  const [selectedPrice, setSelectedPrice] = useState(price[0].value);
  const handleRadioChange = (event) => {
    setSelectedPrice(event.target.value);
  };

  // console.log("selectedPrice", selectedPrice);
  // const [isChecked, setIsChecked] = useState(() => {
  //   const savedValue = sessionStorage.getItem("isChecked");
  //   return savedValue ? JSON.parse(savedValue) : false;
  // });
  // useEffect(() => {
  //   sessionStorage.getItem("isChecked");
  //   console.log("isChecked", isChecked);
  // }, [isChecked]);

  const handleSelectChange = (category, id, value, isChecked) => {
    setSelectedValues((prevState) => ({
      ...prevState,
      [category]: isChecked
        ? [...prevState[category], id]
        : prevState[category].filter((item) => item !== id),
    }));
  };
  const handleSubmit = async (e) => {
    // Update session storage whenever isChecked changes
    e.preventDefault();
    setSearchFormQuery(selectedValues);
    setPriceOrder(selectedPrice);
    setIsSearched(true);
    let driver = sessionStorage.getItem("isChecked");
    // let newErrMsg = {};
    // if (carType?.length === 0) newErrMsg = { ...newErrMsg, carTypeErrMsg: "Enter Car Type" };
    // if (passenger === "") newErrMsg = { ...newErrMsg, seatErrMsg: "Enter Required Seats" };
    // if (location ===  "") newErrMsg = { ...newErrMsg, locationErrMsg: "Enter Pick-up Location" };
    // setErrMsg(newErrMsg)

    if (
      selectedValues?.cartType?.length === 0 &&
      selectedValues?.carMake?.length === 0 &&
      selectedValues?.carModel?.length === 0 &&
      selectedValues?.fuelType?.length === 0 &&
      // selectedValues?.price?.length === 0 &&
      selectedPrice === null &&
      selectedValues?.seatingCapacity?.length === 0
    ) {
      toast("Please Select atleast one Filter");

      return;
    } else {
      if (setCurrentPage) setCurrentPage(1);
      // dispatch(
      //   filterCars({
      //     filterQuery: {
      //       carType: selectedValues?.cartType,
      //       carmaker: selectedValues?.carMake,
      //       carmodel: selectedValues?.carModel,
      //       numberOfSeats: selectedValues?.seatingCapacity,
      //       fuelType: selectedValues?.fuelType,
      //     },
      //     userId: userDetail?.data?._id,
      //     userLat: "",
      //     userLong: "",
      //     pickUpDateandTime: "",
      //     returnDateandTime: "",
      //     price: selectedPrice,
      //     withDriver: driver,
      //   })
      // );
    }
  };

  const clearFilters = () => {
    setIsSearched(false);
    setSearchFormQuery({
      cartType: [],
      carMake: [],
      carModel: [],
      fuelType: [],
      price: [],
      seatingCapacity: [],
    });
    setPriceOrder(1);
    let driver = sessionStorage.getItem("isChecked");
    setSelectedValues({
      cartType: [],
      carMake: [],
      carModel: [],
      fuelType: [],
      price: [],
      seatingCapacity: [],
    });

    setSelectedPrice(price[0].value);

    // Trigger onChange event for each checkbox to uncheck them
    document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event("change"));
    });

    // Call the filterCars API with an empty filterQuery object to reset the filters
    // dispatch(
    //   filterCars({
    //     filterQuery: {
    //       carType: [],
    //       carmaker: [],
    //       carmodel: [],
    //       numberOfSeats: [],
    //       fuelType: [],
    //     },
    //     userId: userDetail?.data?._id,
    //     userLat: "",
    //     userLong: "",
    //     pickUpDateandTime: "",
    //     returnDateandTime: "",
    //     // price: null,
    //     price: 1,
    //     withDriver: driver,
    //   })
    // );
  };
  // const handleCheckboxChange = (event) => {
  //   setIsChecked(event.target.checked);
  //   // setCurrentPage(1); // Reset to first page when filter changes
  // };
  // useEffect(() => {
  //   dispatch(
  //     filterCars({
  //       filterQuery: {
  //         carType: selectedValues?.cartType,
  //         carmaker: selectedValues?.carMake,
  //         carmodel: selectedValues?.carModel,
  //         numberOfSeats: selectedValues?.seatingCapacity,
  //         fuelType: selectedValues?.fuelType,
  //       },
  //       // userId: "661a5a9e155539e4bf273268",
  //       userId: userDetail?.data?._id,
  //       userLat: "",
  //       userLong: "",
  //       pickUpDateandTime: "",
  //       returnDateandTime: "",
  //       price: selectedPrice,
  //       withDriver: isChecked,
  //     })
  //   );
  // }, [isChecked]);

  // useEffect(() => {
  //   setSearchFormQuery(selectedValues);
  // }, [selectedValues]);
  return (
    <div>
      {/* <h5 className="my-2 secondaryColor ">Car Type</h5> */}
      {/* <div className="d-flex justify-content-between align-items-end">
        <h5 className="my-2 secondaryColor ">Car Type</h5>
        <div>
          <h5 className="pe-3 secondaryColor pb-2"> With Driver</h5>
          <AntSwitch
            onChange={handleCheckboxChange}
            checked={isChecked}
            inputProps={{ "aria-label": "ant design" }}
          />
        </div>
      </div> */}

      {/* <div className="d-flex flex-wrap gap-2">
        {categoriesData?.map((item, index) => {
          return (
            <div key={item?._id}>
              <Checkbox
                onChange={(isChecked) =>
                  handleSelectChange(
                    "cartType",
                    item?._id,
                    item?.categoryName,
                    isChecked
                  )
                }
                name={item?.categoryName}
                id={item?._id}
              />
            </div>
          );
        })}
      </div> */}
      <h5 className="my-2 secondaryColor">Car Make</h5>
      <div className="d-flex flex-wrap gap-2">
        {carMakeList?.map((item, index) => {
          return (
            <div key={item?._id}>
              <Checkbox
                onChange={(isChecked) =>
                  handleSelectChange(
                    "carMake",
                    item?._id,
                    item?.carMake,
                    isChecked
                  )
                }
                name={item?.carMake}
                id={item?._id}
              />
            </div>
          );
        })}
      </div>
      <h5 className="my-2 secondaryColor">Car Model</h5>
      <div className="d-flex flex-wrap gap-2">
        {carModals?.map((item, index) => {
          return (
            <div key={item?._id}>
              <Checkbox
                onChange={(isChecked) =>
                  handleSelectChange(
                    "carModel",
                    item?._id,
                    item?.carModel,
                    isChecked
                  )
                }
                name={item?.carModel}
                id={item?._id}
              />
            </div>
          );
        })}
      </div>
      <h5 className="my-2 secondaryColor">Fuel Type</h5>
      <div className="d-flex flex-wrap gap-2">
        {fuelType?.map((item, index) => {
          return (
            <div key={item?._id}>
              <Checkbox
                onChange={(isChecked) =>
                  handleSelectChange(
                    "fuelType",
                    item?._id,
                    item?.name,
                    isChecked
                  )
                }
                name={item?.name}
                id={item?._id}
              />
            </div>
          );
        })}
      </div>
      <h5 className="my-2 secondaryColor">Price</h5>
      <div className="d-flex flex-wrap gap-2">
        {price?.map((item, index) => {
          return (
            <div key={item?._id}>
              <RadioInput
                id={item?._id}
                name={item?.name}
                lable={item?.lable}
                value={item?.value}
                checked={+selectedPrice === +item.value}
                onChange={handleRadioChange}
              />
            </div>
          );
        })}
      </div>
      {/* <h5 className="my-2 secondaryColor">Seating Capacity</h5>
      <div className="d-flex flex-wrap gap-2">
        {seatList?.map((item, index) => {
          return (
            <div key={item?._id}>
              <Checkbox
                onChange={(isChecked) =>
                  handleSelectChange(
                    "seatingCapacity",
                    item?._id,
                    item?.name,
                    isChecked
                  )
                }
                name={item?.name}
                id={item?._id}
              />
            </div>
          );
        })}
      </div> */}
      {/* <div className="d-flex mt-3">
        <h5 className="pe-3 secondaryColor "> With Driver</h5>
        <AntSwitch
          onChange={handleCheckboxChange}
          checked={isChecked}
          inputProps={{ "aria-label": "ant design" }}
        />
      </div> */}
      {/* 
      <div>
        <h5 className='my-2 secondaryColor' >Body Type</h5>
        <div className='d-flex flex-wrap gap-2' >
          {categories?.map((category) => {
            return <div key={category._id} >
              <Checkbox
                name={category?.categoryName}
              />
            </div>
          })}

          <div>
            <Checkbox
              onChange={isChecked => handleSelectChange("cartType", "All", isChecked)}
              name="All"
            />
          </div>
          <div>
            <Checkbox
              name="Hatchback"
              onChange={isChecked => handleSelectChange("cartType", "Hatchback", isChecked)}
            />
          </div>
          <div>
            <Checkbox
              name="Compact Suv"
            />
          </div>
          <div>
            <Checkbox
              name="Suv"
            />
          </div>
          <div>
            <Checkbox
              name="Sedan"
            />
          </div>
          <div>
            <Checkbox
              name="MPV"
            />
          </div>
          <div>
            <Checkbox
              name="Luxury"
              onChange={isChecked => handleSelectChange("cartType", "Luxury", isChecked)}
            />
          </div>
        </div>
      </div> */}
      {/* <div className='my-4' >
        <h5 className='my-2 secondaryColor' >Price</h5>
        <div className='d-flex flex-wrap gap-2' >
          <div>
            <Checkbox
              name="Low to high"
            />
          </div>
          <div>
            <Checkbox
              name="High to low"
            />
          </div>

        </div>
        <h5 className='my-2 secondaryColor' >Car Make</h5>
        <div className='d-flex flex-wrap gap-2' >

          <div>
            <Checkbox
              name="Honda"
            />
          </div>
          <div>
            <Checkbox
              name="Hyundai"
            />
          </div>
          <div>
            <Checkbox
              name="Audi"
            />
          </div>
          <div>
            <Checkbox
              name="Nissan"
            />
          </div>
          <div>
            <Checkbox
              name="BMW "
            />
          </div>
          <div>
            <Checkbox
              name="Mercedes-Benz"
            />
          </div>
          <div>
            <Checkbox
              name="Toyota"
            />
          </div>
          <div>
            <Checkbox
              name="Ford"
            />
          </div>
        </div>

      </div> */}
      {/* <div className='my-4' >
        <h5 className='my-2 secondaryColor' >Car Model</h5>
        <div className='d-flex flex-wrap gap-2' >
          <div>
            <Checkbox
              name="Hyundai Sonata"
            />
          </div>
          <div>
            <Checkbox
              name="Nissan Rogue"
            />
          </div>
          <div>
            <Checkbox
              name="Volkswagen Golf"
            />
          </div>
          <div>
            <Checkbox
              name="Chevrolet Silverado"
            />
          </div>
          <div>
            <Checkbox
              name="Ford F-150 "
            />
          </div>
          <div>
            <Checkbox
              name="Toyota Camry"
            />
          </div>
        </div>
      </div>
      <div className='my-4' >
        <h5 className='my-2 secondaryColor' >Fuel Type</h5>
        <div className='d-flex flex-wrap gap-2' >
          <div>
            <Checkbox
              name="Diesel"
            />
          </div>
          <div>
            <Checkbox
              name="Petrol"
            />
          </div>
          <div>
            <Checkbox
              name="Electric"
            />
          </div>
          <div>
            <Checkbox
              name="Hybrid"
            />
          </div>


        </div>
      </div>
      <div className='my-4' >
        <h5 className='my-2 secondaryColor' >Price</h5>
        <div className='d-flex flex-wrap gap-2' >
          <div>
            <Checkbox
              name="Low to High"
            />
          </div>
          <div>
            <Checkbox
              name="High to Low"
            />
          </div>



        </div>
      </div>
      <div>
        <h5 className='my-2 secondaryColor' >Seating Capacity</h5>
        <div className='d-flex flex-wrap gap-2' >
          <div>
            <Checkbox
              name="2 Seater"
            />
          </div>
          <div>
            <Checkbox
              name="3 seater"
            />
          </div>
          <div>
            <Checkbox
              name="4 seater"
            />
          </div>
          <div>
            <Checkbox
              name="5 seater"
            />
          </div>
          <div>
            <Checkbox
              name="6 seater"
            />
          </div>
          <div>
            <Checkbox
              name="7+ seater"
            />
          </div>
        </div>

      </div> */}
      <div className="align-items-center d-flex gap-2 mt-4">
        <button
          type="button"
          className="btn img-btn px-5 primaryColor "
          // {...(isClose && { "data-bs-dismiss": "modal" })}
          data-bs-dismiss="modal"
          onClick={handleSubmit}
        >
          Apply
        </button>
        <button
          type="button"
          data-bs-dismiss="modal"
          className="btn img-btn px-5 primaryColor "
          onClick={clearFilters}
        >
          Clear Filter
        </button>
      </div>
    </div>
  );
};

export default CustomSelection;
